export default __webpack_public_path__ + "static/weingut-goeschl-logo-b8499ebea7181c47c66466fca1c6f8f6.png";